/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-06-05 11:58:53
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-06-05 11:59:19
 * @FilePath: \合联\oms\src\api\priceRule\dduRule.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = ''

export const apis = buildApi({
  get: ['/quotation/tax/ddu&list', '/quotation/tax/ddu/:id&detail'],
  post: ['/quotation/tax/ddu/batchDelete&delete', '/quotation/tax/ddu&add'],
  put: ['/quotation/tax/ddu/:id&update'],
})